export default {
  patient: {
    firstName: 'الاسم الاول',
    lastName: 'الكنية',
    medications: {
      label: 'الأدوية',
      new: 'أضف دواء جديد',
      warning: {
        noMedications: 'لا أدوية',
      },
      noMedicationsMessage: 'لا توجد طلبات أدوية لهذا الشخص.',
    },
  },
}
